import HeroBg from "public/openStack/hero-section-background.png";

export const HERO_CONSTANTS = {
  desc: "Open-source cloud computing platform for seamless resource orchestration.",
  title: "OneMind's Managed OpenStack (MOST)",
  button: {
    label: "Start Free Trial",
    link: "contact-us",
  },
  button2: {
    label: "Schedule a Demo",
    link: "contact-us",
  },
  image: HeroBg,
};
